import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';
import journalImg from '../../assets/images/journal.webp';
import achievementsImg from '../../assets/images/achivements.webp';
import builtForYouImg from '../../assets/images/built-for-you-customise.webp';
import aboutWaterImg from '../../assets/images/about-water.webp';
import { siteCopy } from '../../content/siteCopy';

/** About carousel only — custom screenshots in src/assets/images/. */
const aboutSliderSlides = [
  {
    id: 'journal',
    image: journalImg,
    alt: 'Noor quick journal screen',
  },
  {
    id: 'achievements',
    image: achievementsImg,
    alt: 'Noor achievements and progress milestones',
  },
  {
    id: 'built-for-you',
    image: builtForYouImg,
    alt: 'Noor built for you — personalised app experience',
  },
  {
    id: 'about-water',
    image: aboutWaterImg,
    alt: 'Noor water intake on the home screen',
  },
];

const slider = {
  loop: true,
  spaceBetween: 24,
  breakpoints: {
    0: { slidesPerView: 1 },
    740: { slidesPerView: 2 },
    1200: { slidesPerView: 2 },
  },
};

const Aboutus = () => {
  const { whoWeAre } = siteCopy.aboutUs;

  return (
    <>
      <section className="about_us_section">
        <div className="container">
          <div className="section_title" data-aos="fade-up" data-aos-duration={1500}>
            <span className="title_badge">{whoWeAre.badge}</span>
            <h2>{whoWeAre.title}</h2>
            <p>{whoWeAre.body}</p>
          </div>
        </div>
        <div className="container">
          <div
            className="about_slider row_am"
            data-aos="fade-in"
            data-aos-duration={1500}
          >
            <Swiper
              className="mySwiper about_screenshot_swiper"
              id="about_slider"
              modules={[Autoplay]}
              autoplay
              {...slider}
            >
              {aboutSliderSlides.map((slide) => (
                <SwiperSlide className="item" key={slide.id}>
                  <div className="abt_slides">
                    <img src={slide.image} alt={slide.alt} />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section>
    </>
  );
};

export default Aboutus;
